import english from './base/en-us.json'
import german from './base/de.json'
import malay from './base/malay.json'
import french from './base/fr.json'
import spanish from './base/es.json'
import italian from './base/it.json'
import japanese from './base/ja.json'
import portuguese from './base/pt.json'

export default {
  'en-us': english,
  'de': german,
  'ms': malay,
  'fr': french,
  'es': spanish,
  'it': italian,
  'ja': japanese,
  'pt': portuguese
}
